// This file was auto-generated by Fern from our API Definition.
const SupportedSdkLanguageValues = {
    Curl: "curl",
    Python: "python",
    Javascript: "javascript",
    Typescript: "typescript",
    Go: "go",
    Ruby: "ruby",
    Csharp: "csharp",
    Java: "java",
    Php: "php",
    Rust: "rust",
    Swift: "swift",
};
export const SupportedSdkLanguage = Object.assign(Object.assign({}, SupportedSdkLanguageValues), { _visit: (value, visitor) => {
        switch (value) {
            case SupportedSdkLanguage.Curl:
                return visitor.curl();
            case SupportedSdkLanguage.Python:
                return visitor.python();
            case SupportedSdkLanguage.Javascript:
                return visitor.javascript();
            case SupportedSdkLanguage.Typescript:
                return visitor.typescript();
            case SupportedSdkLanguage.Go:
                return visitor.go();
            case SupportedSdkLanguage.Ruby:
                return visitor.ruby();
            case SupportedSdkLanguage.Csharp:
                return visitor.csharp();
            case SupportedSdkLanguage.Java:
                return visitor.java();
            case SupportedSdkLanguage.Php:
                return visitor.php();
            case SupportedSdkLanguage.Rust:
                return visitor.rust();
            case SupportedSdkLanguage.Swift:
                return visitor.swift();
            default:
                return visitor._other();
        }
    } });
